// Import FirebaseAuth and firebase.
// @ts-nocheck
import React, { useEffect, useState, useContext } from 'react';
import StyledFirebaseAuth from './StyledFirebaseAuth';
import { UserContext } from './UserContext'
import firebase from 'firebase/compat/app';
import { motion, AnimatePresence } from "framer-motion";
import {CircularProgress, Box, Typography} from '@mui/material';
import styled from 'styled-components'
import 'firebase/compat/auth';

// Configure Firebase.
const config = {
  apiKey: 'AIzaSyB3eRni2wZ8Qw7-aGnJF3kJyJ9cW0OoirY',
  authDomain: 'dallpaper.firebaseapp.com',
  // ...
};
firebase.initializeApp(config);

// Configure FirebaseUI.
const uiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: 'popup',
  // We will display Google and Email as auth providers.
  signInOptions: [
    {
        provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
        requireDisplayName: false,
    },
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  ],
  callbacks: {
    // Avoid redirects after sign-in.
    signInSuccessWithAuthResult: () => false,
  },
};


const LoginContainer = styled.div`
  padding: 50px;
  padding-top: 0px;
`

const loadingMessages = [
  "Sorry, Google is busy digging the server out of a closet...",
  "be patient >:( im trying my best...",
  "Will it work? Who knows..",
  "Cold booting the server...",
  "Everything Ye say cause a new debate...",
  "No staring at the spinning icon please. Thank You",
  "My bad, was napping, one sec...",
  "If you refresh the page, it'll take even longer, fun :)"
]

function LoginScreen() {
  const [signedInFirebase, setSignedInFirebase] = useState(false);
  const [signedInDallpaper, setSignedInDallpaper] = useState(false);
  const [badConnection, setBadConnection] = useState(false);
  const [loading, setLoading] = useState(false);
  const {user, setUser} = useContext(UserContext);

  const dallpaperLogin = async (login_user) => {
    if (!user){
      setLoading(true)
      const options =  {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer: ' + login_user.firebase_token},
          body: JSON.stringify({email: login_user.email})
      };

      try {
        const response = await fetch(`${process.env.REACT_APP_DALLPAPER_API_URL}/login`, options)
        const loginResponse = await response.json()
        setLoading(false)
        if (response.ok){
          console.log(
            "Confirmed user in database. Signed into spotify: ", loginResponse.signed_into_spotify,
            "Signed into apple: ", loginResponse.signed_into_apple_music
          )
          // Here we append all the fields from the response onto the user object
          login_user = {...loginResponse, ...login_user}
          setUser(login_user)
          setSignedInDallpaper(true)
          setBadConnection(false)
        }
        else {
          console.log("Failed to login :( Didn't set local user ", loginResponse)
          setSignedInDallpaper(false)
          setLoading(false)
        }
      } catch (e) {
        console.log("Could not reach backend", e)
        setBadConnection(true)
        setLoading(false)
      }
    }
  }

  // Listen to the Firebase Auth state and set the local state.
  useEffect(() => {
    const unregisterAuthObserver = firebase.auth().onAuthStateChanged(async (fbsUser) => {
      console.log("AUTH STATE CHANGE ", fbsUser)
      if(fbsUser && !user){
        const token = await fbsUser.getIdToken()
        const login_user = {firebase_id: fbsUser.uid, firebase_token: token , email: fbsUser.email}
        setSignedInFirebase(true)
        dallpaperLogin(login_user)
      }
      else if (!fbsUser) {
        setSignedInFirebase(false)
        setSignedInDallpaper(false)
        if(!loading){
          setUser(null)
        }
      }
    });
    return () => unregisterAuthObserver(); // Make sure we un-register Firebase observers when the component unmounts.
  }, []);

  const loadingMessage = loadingMessages[Math.floor(Math.random()*loadingMessages.length)];

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ delay: 0.5, duration: 0.5 }}
      >
        <LoginContainer>
          { loading
            ? <Box sx={{ display: 'flex', flexDirection: "column", alignItems: "center", justifyContent: 'center', padding: "30px", width: "100%" }}>
                <CircularProgress color='info' />
                <br/><br/>
                <AnimatePresence>
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ delay: 5, duration: 0.7 }}
                  >
                    <Typography>{loadingMessage}</Typography> 
                  </motion.div>
                </AnimatePresence>
              </Box>
            : !signedInDallpaper &&
              <React.Fragment>
                <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
                {badConnection && <p>Failed to connect to backend... is it running? Try refreshing</p>}
              </React.Fragment>
          }
        </LoginContainer>
      </motion.div>
    </AnimatePresence>
  );
}

export default LoginScreen;